unit Commodities;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, System.Rtti,
  VCL.TMSFNCDataGridCell, VCL.TMSFNCDataGridData, VCL.TMSFNCDataGridBase,
  VCL.TMSFNCDataGridCore, VCL.TMSFNCDataGridRenderer, WEBLib.Buttons,
  VCL.TMSFNCCustomControl, VCL.TMSFNCDataGrid, WEBLib.ComCtrls, Vcl.Controls,
  WEBLib.ExtCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  XData.Web.Client, VCL.TMSFNCCustomComponent, VCL.TMSFNCDataGridDatabaseAdapter,
  Vcl.StdCtrls, WEBLib.StdCtrls, VCL.TMSFNCBitmapContainer;

type
  TfrmComodities = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebPanel3: TPanel;
    WebPageControl1: TPageControl;
    WebPanel5: TPanel;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton3: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton5: TSpeedButton;
    TMSFNCDataGrid1: TTMSFNCDataGrid;
    wcCommodities: TXDataWebClient;
    wdsCommodities: TXDataWebDataSet;
    dsCommodities: TDataSource;
    wdsCommoditiesNO: TIntegerField;
    wdsCommoditiesNAME: TStringField;
    wdsCommoditiesITEMCODE: TStringField;
    wdsCommoditiesSTORE: TIntegerField;
    wdsCommoditiesUNITNUMBER: TStringField;
    wdsCommoditiesDENSITY: TFloatField;
    dgdbaCommodities: TTMSFNCDataGridDatabaseAdapter;
    WebButton1: TButton;
    WebButton2: TButton;
    WebSpeedButton6: TSpeedButton;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton8: TSpeedButton;
    WebSpeedButton9: TSpeedButton;
    edtCommoditiesMaxPC: TEdit;
    BitmapContainer1: TTMSFNCBitmapContainer;
    procedure WebFormShow(Sender: TObject);
    procedure WebSpeedButton6Click(Sender: TObject);
    procedure WebSpeedButton8Click(Sender: TObject);
    procedure WebSpeedButton9Click(Sender: TObject);
    procedure TMSFNCDataGrid1CellClick(Sender: TObject; AColumn, ARow: Integer);
    procedure WebButton1Click(Sender: TObject);
    procedure WebButton2Click(Sender: TObject);
    procedure WebSpeedButton5Click(Sender: TObject);
    procedure TMSFNCDataGrid1GetCellProperties(Sender: TObject;
      ACell: TTMSFNCDataGridCell);
  private
    { Private declarations }
    iCommoditiesPC, iCommoditiesMaxPC : integer;
    procedure LoadCommodities(iPageCount, iNo : Integer);
  public
    { Public declarations }
    iState : Integer;
    iCommodityNo : Integer;
    sCommodityName : String;
  protected procedure LoadDFMValues; override; end;

var
  frmComodities: TfrmComodities;

implementation

{$R *.dfm}

uses
  stfmssystem.connection, share.common, share.classes, CommoditySetup;

procedure TfrmComodities.LoadCommodities(iPageCount, iNo: Integer);
var
  CommoditiesParams : TCommoditiesParams;
  JsonParams : String;
  procedure OnError(Error: TXDataClientError);
    begin
      LoadCommodities(iPageCount,iNo);
    end;
  procedure OnResult(Response : TXDataClientResponse);
    begin
      If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
        begin
          LoadCommodities(iPageCount,iNo);
        end
      else
        begin
          wdsCommodities.Close;
          wdsCommodities.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
          wdsCommodities.Open;
        end;
    end;

    procedure OnResultPC(Response : TXDataClientResponse);
      begin
        If (Response.StatusCode < 200) or (Response.StatusCode > 299) then
          begin
            LoadCommodities(iPageCount,iNo);
          end
        else
          begin
            iCommoditiesMaxPC := Integer(TJSObject(Response.Result)['value']);

            edtCommoditiesMaxPC.Text := IntToStr(iCommoditiesPC) + ' of ' + IntToStr(iCommoditiesMaxPC);
            CommoditiesParams := TCommoditiesParams.Create;
            CommoditiesParams.PageCount := iPageCount;
            CommoditiesParams.No := iNo;

            JsonParams := ConvertObjToJson(CommoditiesParams).ToJSON;

            console.log(jSonParams);

            wcCommodities.RawInvoke('IstfmsloadsService.Get_Commodities_View',[JsonParams],@OnResult,@OnError);

            CommoditiesParams.Free;
          end;

      end;

begin
   wcCommodities.RawInvoke('IstfmsloadsService.Get_Commodities_MaxPC',[],@OnResultPC,@OnError);
end;

procedure TfrmComodities.TMSFNCDataGrid1CellClick(Sender: TObject; AColumn,
  ARow: Integer);

var
  newform : TfrmCommoditySetup;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          LoadCommodities(1,-1);
        end;
    end;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 2;
          iNo := dgdbaCommodities.FieldAtColumn[1].AsInteger;

        end;
    end;
begin
  dgdbaCommodities.SetActiveRecord(ARow);

  if AColumn IN [0..6] then
    Begin
      iCommodityNo := dgdbaCommodities.FieldAtColumn[1].AsInteger;
      sCommodityName := dgdbaCommodities.FieldAtColumn[2].AsString;
    End;

  if AColumn = 7 then
    Begin
      newform := TfrmCommoditySetup.CreateNew(@AfterCreate);
      newform.Popup := true;
      newform.PopupOpacity := 0.2;
      newform.ShowModal(@AfterShowModal);
    end;

  if AColumn = 8 then
    Begin

    End;
end;

procedure TfrmComodities.TMSFNCDataGrid1GetCellProperties(Sender: TObject;
  ACell: TTMSFNCDataGridCell);
begin
  if ACell.IsBitmapCell and dgdbaCommodities.IsValidDataCell(ACell.Coordinate) then
    begin
      if ACell.Column = 7 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[1];

      if ACell.Column = 8 then
        ACell.AsBitmapCell.BitmapName := BitmapContainer1.BitmapNames[0];
    end;
end;

procedure TfrmComodities.WebButton1Click(Sender: TObject);
begin
  Close;
end;

procedure TfrmComodities.WebButton2Click(Sender: TObject);
begin
  sCommodityName := '';
  iCommodityNo := -1;
  Close;
end;

procedure TfrmComodities.WebFormShow(Sender: TObject);
begin
  iCommoditiesPC := 1;
  LoadCommodities(1,-1);
end;

procedure TfrmComodities.WebSpeedButton5Click(Sender: TObject);
var
  newform : TfrmCommoditySetup;

  procedure AfterShowModal(AValue: TModalResult);
    begin
      with newform do
        begin
          LoadCommodities(1,-1);
        end;
    end;
  procedure AfterCreate(AForm: TObject);
    begin
      with newform do
        begin
          iState := 1;
        end;
    end;
begin
  newform := TfrmCommoditySetup.CreateNew(@AfterCreate);
  newform.Popup := true;
  newform.PopupOpacity := 0.2;
  newform.ShowModal(@AfterShowModal);
end;

procedure TfrmComodities.WebSpeedButton6Click(Sender: TObject);
begin
  iCommoditiesPC := 1;
  LoadCommodities(iCommoditiesPC,-1);
end;

procedure TfrmComodities.WebSpeedButton8Click(Sender: TObject);
begin
  if iCommoditiesPC > 1 then
    Begin
      Dec(iCommoditiesPC);
      LoadCommodities(iCommoditiesPC,-1);
    End;
end;

procedure TfrmComodities.WebSpeedButton9Click(Sender: TObject);
begin
  if iCommoditiesPC < iCommoditiesMaxPC then
    Begin
      Inc(iCommoditiesPC);
      LoadCommodities(iCommoditiesPC,-1);
    End;
end;

procedure TfrmComodities.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  BitmapContainer1 := TTMSFNCBitmapContainer.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  WebButton2 := TButton.Create(Self);
  WebSpeedButton6 := TSpeedButton.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton8 := TSpeedButton.Create(Self);
  WebSpeedButton9 := TSpeedButton.Create(Self);
  edtCommoditiesMaxPC := TEdit.Create(Self);
  WebPageControl1 := TPageControl.Create(Self);
  WebPanel5 := TPanel.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton5 := TSpeedButton.Create(Self);
  TMSFNCDataGrid1 := TTMSFNCDataGrid.Create(Self);
  dgdbaCommodities := TTMSFNCDataGridDatabaseAdapter.Create(Self);
  wcCommodities := TXDataWebClient.Create(Self);
  wdsCommodities := TXDataWebDataSet.Create(Self);
  wdsCommoditiesNO := TIntegerField.Create(Self);
  wdsCommoditiesNAME := TStringField.Create(Self);
  wdsCommoditiesITEMCODE := TStringField.Create(Self);
  wdsCommoditiesSTORE := TIntegerField.Create(Self);
  wdsCommoditiesUNITNUMBER := TStringField.Create(Self);
  wdsCommoditiesDENSITY := TFloatField.Create(Self);
  dsCommodities := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  BitmapContainer1.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  WebButton2.BeforeLoadDFMValues;
  WebSpeedButton6.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton8.BeforeLoadDFMValues;
  WebSpeedButton9.BeforeLoadDFMValues;
  edtCommoditiesMaxPC.BeforeLoadDFMValues;
  WebPageControl1.BeforeLoadDFMValues;
  WebPanel5.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton5.BeforeLoadDFMValues;
  TMSFNCDataGrid1.BeforeLoadDFMValues;
  dgdbaCommodities.BeforeLoadDFMValues;
  wcCommodities.BeforeLoadDFMValues;
  wdsCommodities.BeforeLoadDFMValues;
  wdsCommoditiesNO.BeforeLoadDFMValues;
  wdsCommoditiesNAME.BeforeLoadDFMValues;
  wdsCommoditiesITEMCODE.BeforeLoadDFMValues;
  wdsCommoditiesSTORE.BeforeLoadDFMValues;
  wdsCommoditiesUNITNUMBER.BeforeLoadDFMValues;
  wdsCommoditiesDENSITY.BeforeLoadDFMValues;
  dsCommodities.BeforeLoadDFMValues;
  try
    Name := 'frmComodities';
    Width := 800;
    Height := 400;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 800;
    WebPanel1.Height := 400;
    WebPanel1.Align := alClient;
    WebPanel1.TabOrder := 0;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 800;
    WebPanel2.Height := 60;
    WebPanel2.Align := alTop;
    WebPanel2.Caption := 'Comodities Information';
    WebPanel2.Color := clSilver;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -16;
    WebPanel2.Font.Name := 'Segoe UI';
    WebPanel2.Font.Style := [fsBold];
    WebPanel2.ParentFont := False;
    WebPanel2.TabOrder := 0;
    BitmapContainer1.SetParentComponent(WebPanel2);
    BitmapContainer1.Name := 'BitmapContainer1';
    BitmapContainer1.Left := 568;
    BitmapContainer1.Top := 24;
    BitmapContainer1.Width := 26;
    BitmapContainer1.Height := 26;
    BitmapContainer1.Visible := True;
    BitmapContainer1.Items.Clear;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('Commodities.BitmapContainer1.Items.Bitmap.svg');
      Name := 'delete.svg';
      Tag := 0;
    end;
    with BitmapContainer1.Items.Add do
    begin
      Bitmap.LoadFromFile('Commodities.BitmapContainer1.Items.Bitmap_1.svg');
      Name := 'edit.svg';
      Tag := 0;
    end;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 340;
    WebPanel3.Width := 800;
    WebPanel3.Height := 60;
    WebPanel3.Align := alBottom;
    WebPanel3.ChildOrder := 1;
    WebPanel3.Color := clSilver;
    WebPanel3.TabOrder := 1;
    WebButton1.SetParentComponent(WebPanel3);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 16;
    WebButton1.Top := 16;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Caption := 'Select';
    WebButton1.Color := clGreenyellow;
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    WebButton2.SetParentComponent(WebPanel3);
    WebButton2.Name := 'WebButton2';
    WebButton2.Left := 144;
    WebButton2.Top := 16;
    WebButton2.Width := 96;
    WebButton2.Height := 25;
    WebButton2.Caption := 'Close';
    WebButton2.Color := clRed;
    WebButton2.ChildOrder := 1;
    WebButton2.HeightPercent := 100.000000000000000000;
    WebButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton2, Self, 'OnClick', 'WebButton2Click');
    WebSpeedButton6.SetParentComponent(WebPanel3);
    WebSpeedButton6.Name := 'WebSpeedButton6';
    WebSpeedButton6.Left := 304;
    WebSpeedButton6.Top := 16;
    WebSpeedButton6.Width := 24;
    WebSpeedButton6.Height := 24;
    WebSpeedButton6.Caption := '<<';
    WebSpeedButton6.Color := clNone;
    WebSpeedButton6.HeightPercent := 100.000000000000000000;
    WebSpeedButton6.TabOrder := 2;
    WebSpeedButton6.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton6, Self, 'OnClick', 'WebSpeedButton6Click');
    WebSpeedButton7.SetParentComponent(WebPanel3);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 465;
    WebSpeedButton7.Top := 16;
    WebSpeedButton7.Width := 24;
    WebSpeedButton7.Height := 24;
    WebSpeedButton7.Caption := '>>';
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.TabOrder := 3;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    WebSpeedButton8.SetParentComponent(WebPanel3);
    WebSpeedButton8.Name := 'WebSpeedButton8';
    WebSpeedButton8.Left := 334;
    WebSpeedButton8.Top := 16;
    WebSpeedButton8.Width := 24;
    WebSpeedButton8.Height := 24;
    WebSpeedButton8.Caption := '<';
    WebSpeedButton8.Color := clNone;
    WebSpeedButton8.HeightPercent := 100.000000000000000000;
    WebSpeedButton8.TabOrder := 4;
    WebSpeedButton8.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton8, Self, 'OnClick', 'WebSpeedButton8Click');
    WebSpeedButton9.SetParentComponent(WebPanel3);
    WebSpeedButton9.Name := 'WebSpeedButton9';
    WebSpeedButton9.Left := 435;
    WebSpeedButton9.Top := 16;
    WebSpeedButton9.Width := 24;
    WebSpeedButton9.Height := 24;
    WebSpeedButton9.Caption := '>';
    WebSpeedButton9.Color := clNone;
    WebSpeedButton9.HeightPercent := 100.000000000000000000;
    WebSpeedButton9.TabOrder := 5;
    WebSpeedButton9.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton9, Self, 'OnClick', 'WebSpeedButton9Click');
    edtCommoditiesMaxPC.SetParentComponent(WebPanel3);
    edtCommoditiesMaxPC.Name := 'edtCommoditiesMaxPC';
    edtCommoditiesMaxPC.Left := 364;
    edtCommoditiesMaxPC.Top := 16;
    edtCommoditiesMaxPC.Width := 65;
    edtCommoditiesMaxPC.Height := 25;
    edtCommoditiesMaxPC.Alignment := taCenter;
    edtCommoditiesMaxPC.ChildOrder := 6;
    edtCommoditiesMaxPC.HeightPercent := 100.000000000000000000;
    edtCommoditiesMaxPC.Text := '0 of 0';
    edtCommoditiesMaxPC.WidthPercent := 100.000000000000000000;
    WebPageControl1.SetParentComponent(WebPanel1);
    WebPageControl1.Name := 'WebPageControl1';
    WebPageControl1.Left := 0;
    WebPageControl1.Top := 60;
    WebPageControl1.Width := 800;
    WebPageControl1.Height := 280;
    WebPageControl1.Align := alClient;
    WebPageControl1.ChildOrder := 2;
    WebPageControl1.TabOrder := 2;
    WebPanel5.SetParentComponent(WebPageControl1);
    WebPanel5.Name := 'WebPanel5';
    WebPanel5.Left := 0;
    WebPanel5.Top := 0;
    WebPanel5.Width := 800;
    WebPanel5.Height := 60;
    WebPanel5.Align := alTop;
    WebPanel5.ChildOrder := 2;
    WebPanel5.Color := clSilver;
    WebPanel5.TabOrder := 0;
    WebSpeedButton1.SetParentComponent(WebPanel5);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 16;
    WebSpeedButton1.Top := 8;
    WebSpeedButton1.Width := 45;
    WebSpeedButton1.Height := 45;
    WebSpeedButton1.Caption := '<<';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.TabOrder := 0;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    WebSpeedButton2.SetParentComponent(WebPanel5);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 67;
    WebSpeedButton2.Top := 8;
    WebSpeedButton2.Width := 45;
    WebSpeedButton2.Height := 45;
    WebSpeedButton2.Caption := '<';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.TabOrder := 1;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    WebSpeedButton3.SetParentComponent(WebPanel5);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 118;
    WebSpeedButton3.Top := 8;
    WebSpeedButton3.Width := 45;
    WebSpeedButton3.Height := 45;
    WebSpeedButton3.Caption := '>';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.TabOrder := 2;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    WebSpeedButton4.SetParentComponent(WebPanel5);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 169;
    WebSpeedButton4.Top := 8;
    WebSpeedButton4.Width := 45;
    WebSpeedButton4.Height := 45;
    WebSpeedButton4.Caption := '>>';
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.TabOrder := 3;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    WebSpeedButton5.SetParentComponent(WebPanel5);
    WebSpeedButton5.Name := 'WebSpeedButton5';
    WebSpeedButton5.Left := 220;
    WebSpeedButton5.Top := 8;
    WebSpeedButton5.Width := 45;
    WebSpeedButton5.Height := 45;
    WebSpeedButton5.Caption := '+';
    WebSpeedButton5.Color := clNone;
    WebSpeedButton5.HeightPercent := 100.000000000000000000;
    WebSpeedButton5.TabOrder := 4;
    WebSpeedButton5.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton5, Self, 'OnClick', 'WebSpeedButton5Click');
    TMSFNCDataGrid1.SetParentComponent(WebPageControl1);
    TMSFNCDataGrid1.Name := 'TMSFNCDataGrid1';
    TMSFNCDataGrid1.Left := 0;
    TMSFNCDataGrid1.Top := 60;
    TMSFNCDataGrid1.Width := 800;
    TMSFNCDataGrid1.Height := 220;
    TMSFNCDataGrid1.Align := alClient;
    TMSFNCDataGrid1.ParentDoubleBuffered := False;
    TMSFNCDataGrid1.DoubleBuffered := True;
    TMSFNCDataGrid1.TabOrder := 1;
    TMSFNCDataGrid1.ShowAcceleratorChar := False;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Color := clWindowText;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Height := -12;
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.Header.VisualGrouping.Layout.Font.Style := [];
    TMSFNCDataGrid1.Adapter := dgdbaCommodities;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FilterInverseMatchLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.BandLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FixedSelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.FocusedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.GroupLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.NormalLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SelectedLayout.Font.Style := [];
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Color := clWindowText;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Height := -12;
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.CellAppearance.SummaryLayout.Font.Style := [];
    TMSFNCDataGrid1.ColumnCount := 9;
    TMSFNCDataGrid1.Columns.Clear;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := '.';
      Settings := [gcsEditorItems];
      Width := 25.000000000000000000;
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'No';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Name';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Item Code';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Store';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Unit Number';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Density';
      Settings := [gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Edit';
      Settings := [gcsType,gcsEditorItems];
    end;
    with TMSFNCDataGrid1.Columns.Add do
    begin
      &Type := gcitBitmap;
      Appearance.FilterMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterMatchLayout.Font.Color := clWindowText;
      Appearance.FilterMatchLayout.Font.Height := -12;
      Appearance.FilterMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterMatchLayout.Font.Style := [];
      Appearance.FilterInverseMatchLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FilterInverseMatchLayout.Font.Color := clWindowText;
      Appearance.FilterInverseMatchLayout.Font.Height := -12;
      Appearance.FilterInverseMatchLayout.Font.Name := 'Segoe UI';
      Appearance.FilterInverseMatchLayout.Font.Style := [];
      Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.BandLayout.Font.Color := clWindowText;
      Appearance.BandLayout.Font.Height := -12;
      Appearance.BandLayout.Font.Name := 'Segoe UI';
      Appearance.BandLayout.Font.Style := [];
      Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedLayout.Font.Color := clWindowText;
      Appearance.FixedLayout.Font.Height := -12;
      Appearance.FixedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedLayout.Font.Style := [];
      Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FixedSelectedLayout.Font.Color := clWindowText;
      Appearance.FixedSelectedLayout.Font.Height := -12;
      Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
      Appearance.FixedSelectedLayout.Font.Style := [];
      Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.FocusedLayout.Font.Color := clWindowText;
      Appearance.FocusedLayout.Font.Height := -12;
      Appearance.FocusedLayout.Font.Name := 'Segoe UI';
      Appearance.FocusedLayout.Font.Style := [];
      Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.GroupLayout.Font.Color := clWindowText;
      Appearance.GroupLayout.Font.Height := -12;
      Appearance.GroupLayout.Font.Name := 'Segoe UI';
      Appearance.GroupLayout.Font.Style := [];
      Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.NormalLayout.Font.Color := clWindowText;
      Appearance.NormalLayout.Font.Height := -12;
      Appearance.NormalLayout.Font.Name := 'Segoe UI';
      Appearance.NormalLayout.Font.Style := [];
      Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SelectedLayout.Font.Color := clWindowText;
      Appearance.SelectedLayout.Font.Height := -12;
      Appearance.SelectedLayout.Font.Name := 'Segoe UI';
      Appearance.SelectedLayout.Font.Style := [];
      Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
      Appearance.SummaryLayout.Font.Color := clWindowText;
      Appearance.SummaryLayout.Font.Height := -12;
      Appearance.SummaryLayout.Font.Name := 'Segoe UI';
      Appearance.SummaryLayout.Font.Style := [];
      Header := 'Delete';
      Settings := [gcsType,gcsEditorItems];
    end;
    TMSFNCDataGrid1.Designer := False;
    TMSFNCDataGrid1.FilterAppearance.Font.Charset := DEFAULT_CHARSET;
    TMSFNCDataGrid1.FilterAppearance.Font.Color := clWindowText;
    TMSFNCDataGrid1.FilterAppearance.Font.Height := -12;
    TMSFNCDataGrid1.FilterAppearance.Font.Name := 'Segoe UI';
    TMSFNCDataGrid1.FilterAppearance.Font.Style := [];
    TMSFNCDataGrid1.Icons.ExpandIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.ExpandIcon.svg');
    TMSFNCDataGrid1.Icons.CollapseIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.CollapseIcon.svg');
    TMSFNCDataGrid1.Icons.FilterIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.FilterIcon.svg');
    TMSFNCDataGrid1.Icons.FilterActiveIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.FilterActiveIcon.svg');
    TMSFNCDataGrid1.Icons.FilterClearIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.FilterClearIcon.svg');
    TMSFNCDataGrid1.Icons.FilterTypeIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.FilterTypeIcon.svg');
    TMSFNCDataGrid1.Icons.SortAscendingIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.SortAscendingIcon.svg');
    TMSFNCDataGrid1.Icons.SortDescendingIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.SortDescendingIcon.svg');
    TMSFNCDataGrid1.Icons.CloseIcon.LoadFromFile('Commodities.WebPageControl1.TMSFNCDataGrid1.Icons.CloseIcon.svg');
    SetEvent(TMSFNCDataGrid1, Self, 'OnCellClick', 'TMSFNCDataGrid1CellClick');
    SetEvent(TMSFNCDataGrid1, Self, 'OnGetCellProperties', 'TMSFNCDataGrid1GetCellProperties');
    TMSFNCDataGrid1.RowCount := 1;
    dgdbaCommodities.SetParentComponent(TMSFNCDataGrid1);
    dgdbaCommodities.Name := 'dgdbaCommodities';
    dgdbaCommodities.Left := 252;
    dgdbaCommodities.Top := 48;
    dgdbaCommodities.Width := 26;
    dgdbaCommodities.Height := 26;
    dgdbaCommodities.Visible := True;
    dgdbaCommodities.AutoCreateColumns := False;
    dgdbaCommodities.AutoRemoveColumns := False;
    dgdbaCommodities.Columns.Clear;
    with dgdbaCommodities.Columns.Add do
    begin
      AutoCreated := False;
    end;
    with dgdbaCommodities.Columns.Add do
    begin
      FieldName := 'NO';
      Header := 'No';
      AutoCreated := False;
    end;
    with dgdbaCommodities.Columns.Add do
    begin
      FieldName := 'NAME';
      Header := 'Name';
      AutoCreated := False;
    end;
    with dgdbaCommodities.Columns.Add do
    begin
      FieldName := 'ITEMCODE';
      Header := 'Item Code';
      AutoCreated := False;
    end;
    with dgdbaCommodities.Columns.Add do
    begin
      FieldName := 'STORE';
      Header := 'Store';
      AutoCreated := False;
    end;
    with dgdbaCommodities.Columns.Add do
    begin
      FieldName := 'UNITNUMBER';
      Header := 'Unit Number';
      AutoCreated := False;
    end;
    with dgdbaCommodities.Columns.Add do
    begin
      FieldName := 'DENSITY';
      Header := 'Density';
      AutoCreated := False;
    end;
    with dgdbaCommodities.Columns.Add do
    begin
      Header := 'Edit';
      AutoCreated := False;
    end;
    with dgdbaCommodities.Columns.Add do
    begin
      Header := 'Delete';
      AutoCreated := False;
    end;
    dgdbaCommodities.DataSource := dsCommodities;
    wcCommodities.SetParentComponent(Self);
    wcCommodities.Name := 'wcCommodities';
    wcCommodities.Connection := dmData.dbConnect;
    wcCommodities.Left := 56;
    wcCommodities.Top := 168;
    wdsCommodities.SetParentComponent(Self);
    wdsCommodities.Name := 'wdsCommodities';
    wdsCommodities.Connection := dmData.dbConnect;
    wdsCommodities.Left := 120;
    wdsCommodities.Top := 168;
    wdsCommoditiesNO.SetParentComponent(wdsCommodities);
    wdsCommoditiesNO.Name := 'wdsCommoditiesNO';
    wdsCommoditiesNO.FieldName := 'NO';
    wdsCommoditiesNAME.SetParentComponent(wdsCommodities);
    wdsCommoditiesNAME.Name := 'wdsCommoditiesNAME';
    wdsCommoditiesNAME.FieldName := 'NAME';
    wdsCommoditiesITEMCODE.SetParentComponent(wdsCommodities);
    wdsCommoditiesITEMCODE.Name := 'wdsCommoditiesITEMCODE';
    wdsCommoditiesITEMCODE.FieldName := 'ITEMCODE';
    wdsCommoditiesSTORE.SetParentComponent(wdsCommodities);
    wdsCommoditiesSTORE.Name := 'wdsCommoditiesSTORE';
    wdsCommoditiesSTORE.FieldName := 'STORE';
    wdsCommoditiesUNITNUMBER.SetParentComponent(wdsCommodities);
    wdsCommoditiesUNITNUMBER.Name := 'wdsCommoditiesUNITNUMBER';
    wdsCommoditiesUNITNUMBER.FieldName := 'UNITNUMBER';
    wdsCommoditiesDENSITY.SetParentComponent(wdsCommodities);
    wdsCommoditiesDENSITY.Name := 'wdsCommoditiesDENSITY';
    wdsCommoditiesDENSITY.FieldName := 'DENSITY';
    dsCommodities.SetParentComponent(Self);
    dsCommodities.Name := 'dsCommodities';
    dsCommodities.DataSet := wdsCommodities;
    dsCommodities.Left := 192;
    dsCommodities.Top := 168;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    BitmapContainer1.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    WebButton2.AfterLoadDFMValues;
    WebSpeedButton6.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton8.AfterLoadDFMValues;
    WebSpeedButton9.AfterLoadDFMValues;
    edtCommoditiesMaxPC.AfterLoadDFMValues;
    WebPageControl1.AfterLoadDFMValues;
    WebPanel5.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton5.AfterLoadDFMValues;
    TMSFNCDataGrid1.AfterLoadDFMValues;
    dgdbaCommodities.AfterLoadDFMValues;
    wcCommodities.AfterLoadDFMValues;
    wdsCommodities.AfterLoadDFMValues;
    wdsCommoditiesNO.AfterLoadDFMValues;
    wdsCommoditiesNAME.AfterLoadDFMValues;
    wdsCommoditiesITEMCODE.AfterLoadDFMValues;
    wdsCommoditiesSTORE.AfterLoadDFMValues;
    wdsCommoditiesUNITNUMBER.AfterLoadDFMValues;
    wdsCommoditiesDENSITY.AfterLoadDFMValues;
    dsCommodities.AfterLoadDFMValues;
  end;
end;

end.
